import { FormControl, Grid, InputLabel, MenuItem, Paper, Select, Typography } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { FilterList } from '@mui/icons-material';
import { MONTH_RANGE_OPTIONS, SUBSCRIPTION_OPTIONS } from './messagesUtils';

const monthPickerSlotProps = {
  textField: { size: 'small', fullWidth: true },
};

const MessagesFilters = ({
  monthRange,
  startMonth,
  endMonth,
  subscription,
  onMonthRangeChange,
  onStartMonthChange,
  onEndMonthChange,
  onSubscriptionChange,
}) => (
  <Paper sx={{ p: 2, mb: 0, mt: 2, width: '100%' }}>
    <Grid container spacing={1} alignItems="center" justifyContent="center">
      <Typography variant="h6" sx={{ mr: 1 }}>
        <FilterList fontSize="small" sx={{ mr: 1, verticalAlign: 'middle' }} />
        Filters
      </Typography>
      <Grid item xs={12} md={2.5}>
        <FormControl fullWidth size="small">
          <InputLabel>Month Range</InputLabel>
          <Select
            value={monthRange}
            label="Month Range"
            onChange={(e) => onMonthRangeChange(e.target.value)}
          >
            {MONTH_RANGE_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={2.5}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Start Month"
            views={['year', 'month']}
            openTo="month"
            value={startMonth}
            onChange={onStartMonthChange}
            slotProps={monthPickerSlotProps}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} md={2.5}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="End Month"
            views={['year', 'month']}
            openTo="month"
            value={endMonth}
            onChange={onEndMonthChange}
            slotProps={monthPickerSlotProps}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} md={2.5}>
        <FormControl fullWidth size="small">
          <InputLabel>Subscription</InputLabel>
          <Select
            value={subscription}
            label="Subscription"
            onChange={(e) => onSubscriptionChange(e.target.value)}
          >
            {SUBSCRIPTION_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  </Paper>
);

export default MessagesFilters;
